import { BrandEntry } from '../types'
import { approvedContent, unreviewed } from './shared'

interface BrandSeed {
  slug: string
  brandName: string
  activeIngredient: string
}

/**
 * Priority brands, all with equal standing (PRD §9). Adding a brand = adding one seed.
 *
 * REQUIRES MEDICAL REVIEW — the only fact filled is the brand → molecule relation from PRD §30.
 * Manufacturer, Anvisa indication, regulatory status, doses, frequency, prescription rules and price
 * are intentionally undefined: do not fill them without a primary source and medical/legal sign-off.
 */
const BRAND_SEEDS: BrandSeed[] = [
  { slug: 'mounjaro', brandName: 'Mounjaro', activeIngredient: 'tirzepatida' },
  { slug: 'wegovy', brandName: 'Wegovy', activeIngredient: 'semaglutida' },
  { slug: 'ozempic', brandName: 'Ozempic', activeIngredient: 'semaglutida' },
  { slug: 'poviztra', brandName: 'Poviztra', activeIngredient: 'semaglutida' },
  { slug: 'semavy', brandName: 'Semavy', activeIngredient: 'semaglutida' },
  { slug: 'ozivy', brandName: 'Ozivy', activeIngredient: 'semaglutida' }
]

export const BRANDS: BrandEntry[] = BRAND_SEEDS.map(({ slug, brandName, activeIngredient }) => ({
  kind: 'brand' as const,
  slug,
  path: `/${slug}`,
  name: brandName,
  brandName,
  activeIngredient,
  published: false,
  requiresReview: true,
  review: unreviewed()
})).map(approvedContent)
